import { render } from "./ImportSupplierCreateUpdate.vue?vue&type=template&id=28e204a0&scoped=true"
import script from "./ImportSupplierCreateUpdate.vue?vue&type=script&lang=js"
export * from "./ImportSupplierCreateUpdate.vue?vue&type=script&lang=js"

import "./ImportSupplierCreateUpdate.vue?vue&type=style&index=0&id=28e204a0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e204a0"]])

export default __exports__